import { Box } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { HowToStep } from '../Constants';

type Props = {
  howToStep: HowToStep;
};

const HowToStepTitleHelper = ({ howToStep }: Props) => {
  if (!howToStep.important) return howToStep.title;

  return (
    <Box
      component="span"
      sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}
    >
      {howToStep.title}
      <Box
        component="span"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          color: 'error.main',
          fontSize: '0.85rem',
          fontWeight: 600,
        }}
      >
        <WarningAmberIcon fontSize="small" />
        {howToStep.important}
      </Box>
    </Box>
  );
};

export default HowToStepTitleHelper;
